import routeRoles from './routeRoles';

const pages = [
  { link: '/home/accounts', name: 'Учётные записи', roles: routeRoles.accounts },
  { link: '/home/stories', name: 'Истории', roles: routeRoles.stories },
  { link: '/home/installs', name: 'Установки', roles: routeRoles.installs },
  { link: '/home/russified-cars', name: 'Русификация', roles: routeRoles.russifiedCars },
  { link: '/home/special-offers', name: 'Спецпредложения', roles: routeRoles.offers },
  { link: '/home/analytics', name: 'Аналитические данные', roles: [...routeRoles.tradein, ...routeRoles.areas, ...routeRoles.dealersAreas] },
  { link: '/home/tech-data', name: 'Техобслуживание', roles: [...routeRoles.carErrors, ...routeRoles.mileage] },
  { link: '/home/moderation', name: 'Установки', roles: routeRoles.moderation },
  { link: '/home/upload-data', name: 'Загрузка данных', roles: routeRoles.uploadExhibitionData },
];

export default pages

export const getStartPage = (userRoles: { [key: number]: string } | undefined) => {
  if (!userRoles) return '/auth';

  const foundPage = pages.find(p => p.roles.some((requiredRole: number) => userRoles[requiredRole] !== undefined));
  if (foundPage) return foundPage.link;
  return '/home';
}
